"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var CheckoutButton = __importStar(require("./A_CheckoutButton"));
var icons = __importStar(require("./icons"));
var styles_1 = require("@mui/material/styles");
// TODO: update disabled styling
var StyledIconButton = (0, styles_1.styled)(IconButton_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        color: 'inherit',
        marginX: '4px',
        '&.Mui-disabled': {
            color: 'inherit',
        },
    });
});
var Component = function (p) {
    return (Preact.h(Preact.Fragment, null,
        Preact.h(StyledIconButton, { onClick: p.onSaveClick, disabled: p.disabled },
            Preact.h(icons.ShareIcon, null)),
        p.onArClick && (Preact.h(StyledIconButton, { onClick: p.onArClick, disabled: p.disabled },
            Preact.h(icons.ArIcon, null))),
        Preact.h(CheckoutButton.Component, { total: p.total, sx: { marginLeft: '10px' }, onBasketClick: p.onBasketClick, disabled: p.disabled })));
};
exports.Component = Component;
